import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const SubtractFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M20.28 17.52C20.28 19.28 19.28 20.28 17.52 20.28H6.76C5 20.28 4 19.28 4 17.52V6.76C4 5 5 4 6.76 4H17.52C19.28 4 20.28 5 20.28 6.76V17.52ZM8.4 11.3V12.96H15.88V11.3H8.4Z"
      />
    </SvgIcon>
  );
});
